import { render, staticRenderFns } from "./Loader.vue?vue&type=template&id=1d51db74&scoped=true"
var script = {}
import style0 from "./Loader.vue?vue&type=style&index=0&id=1d51db74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d51db74",
  null
  
)

export default component.exports